import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { toCurrency } from 'lib/common/displayHelpers';

const Price = ({ priceData, showDescription, isStacked }) => {
  return (
    <span
      className={classnames('syos-price', {
        'syos-price--stacked': isStacked,
        'syos-price--has-description': showDescription
      })}
    >
      {showDescription && (
        <span className="syos-price__description">
          {priceData.price_type_desc}
        </span>
      )}
      <span className="syos-price__value">{toCurrency(priceData.price)}</span>
    </span>
  );
};
Price.propTypes = {
  priceData: PropTypes.shape({
    price: PropTypes.string,
    price_type_desc: PropTypes.string
  }),
  showDescription: PropTypes.bool,
  isStacked: PropTypes.bool
};
Price.defaultProps = {
  isStacked: false,
  showDescription: true
};

export default Price;



// WEBPACK FOOTER //
// ./src/javascripts/components/Price.js